import { useContext, useState } from 'react'
import { message } from 'antd'
import { AppContext } from './AppContext'
//import { CheckpointTypes } from '../types'
import CommonAPIs from '../controller/API/CommonAPIs'
import { GenerateImgType } from '../types/media_type'
//import useTrainLora from './useTrainLora'
import { saveAs } from 'file-saver'
import moment from 'moment'
import { RcFile } from 'antd/es/upload'
import Constant from '../controller/Constant'

const useImg2Img = () => {
  const { showErrorApiAlert, showProcessingAlert } = useContext(AppContext)

  const [imageFile, setImageFile] = useState<RcFile>()
  const [imageBase64, setImageBase64] = useState<string>()
  const [faceImageFile, setFaceImageFile] = useState<RcFile>()
  const [faceImageBase64, setFaceImageBase64] = useState<string>()
  const [isDisable, setIsDisable] = useState<boolean>(false)
  //const [checkPointSelected, setCheckPointSelected] = useState<CheckpointTypes>({
  //  id: 0,
  //  new_checkpoint: '',
  //  name: ''
  //})
  //const [checkPoints, setCheckPoints] = useState<CheckpointTypes[]>([])
  const [generatedImages, setGeneratedImages] = useState<GenerateImgType[]>([])
  const [mediaProcessingJobID, setMediaProcessingJobID] = useState<number>(0)
  const [isStopLoop, setStopLoop] = useState(false)
  const [renderStatus, setRenderStatus] = useState<number>(0)

  const checkIsDisabled = (): boolean => {
    if (mediaProcessingJobID) {
      return true
    }
    return false
  }

  const handleGenerateImg = (): void => {
    if (!imageFile || !faceImageFile) {
      message.error('画像を1枚アップロードしてください。')
      return
    }
    
    setIsDisable(true)
    setGeneratedImages([])
    setStopLoop(false)
    
    CommonAPIs.saveImgs(imageFile, faceImageFile)
      .then(result => {
        CommonAPIs.renderImg2Img(result.background_url, result.face_url)
          .then((res) => {
            showProcessingAlert('画像を生成しています。AIサーバー状況にお時間がかかる場合があります。少々お待ちください')
            setRenderStatus(Constant.processing.PROCESSING)
            setMediaProcessingJobID(res?.job_id)
          })
          .catch((err: any) => showErrorApiAlert(err))
      })
      .catch((err: any) => showErrorApiAlert(err))
  }

  //const getNewCheckpoint = () => {
  //  CommonAPIs.getNewCheckpoint()
  //    .then((res) => {
  //      console.log('new-checkpoint: ', res)
  //      setCheckPoints(res.data)
  //      setCheckPointSelected(res.data[0])
  //    })
  //    .catch((err: any) => {
  //      showErrorApiAlert(err)
  //    })
  //}

  const getMediasProcessing = () => {
    CommonAPIs.renderImg2ImgJob(mediaProcessingJobID)
      .then((res) => {
        console.log('res:', res)
        if ([Constant.processing.SUCCESS, Constant.processing.FAIL].includes(res?.status)) {
          console.log('res?.status:', res?.status)
          if ([Constant.processing.FAIL].includes(res?.status)) {
            setRenderStatus(Constant.processing.FAIL)
          }
          if ([Constant.processing.SUCCESS].includes(res?.status)) {
            setRenderStatus(Constant.processing.SUCCESS)
          }
          setGeneratedImages(res?.medias)
          setStopLoop(true)
          setIsDisable(false)
          setMediaProcessingJobID(0)
        }
      })
      .catch((err) => showErrorApiAlert(err))
  }

  //const handleSelectCheckpoint = (value: any, selected: any) => {
  //  setCheckPointSelected({
  //    id: selected?.key,
  //    new_checkpoint: selected?.new_checkpoint,
  //    name: selected?.value
  //  })
  //}

  const handleDownloadImg = async (imageUrl: string) => {
    try {
      const newDate = moment(new Date()).format('YYYYMMDD')

      const response = await fetch(imageUrl)
      const blob = await response.blob()
      let stringRandom = Math.random().toString(36).substring(7)
      const fileName = `Headswap_${stringRandom}_${newDate.toString()}`
      console.log('fileName:', fileName)
      saveAs(blob, fileName)
    } catch (error) {
      showErrorApiAlert(error)
    }
  }

  return {
    mediaProcessingJobID,
    getMediasProcessing,
    isStopLoop,
    isDisable,
    checkIsDisabled,
    //checkPointSelected,
    //handleSelectCheckpoint,
    //checkPoints,
    //getNewCheckpoint,
    renderStatus,
    handleGenerateImg,
    handleDownloadImg,
    generatedImages,
    imageFile,
    setImageFile,
    imageBase64,
    setImageBase64,
    faceImageFile,
    setFaceImageFile,
    faceImageBase64,
    setFaceImageBase64
  }
}

export default useImg2Img
